import { capitalize } from 'lodash';

export const displayableText = (text: string) =>
  ['IRM', 'DC'].includes(text) ? text : text.split('_').map(capitalize).join(' ');
